module.exports = __webpack_public_path__ + "static/media/doorbell.8371cf67.mp3";